'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getList, toggleInList } from '@/url-state';

export function useActiveInUrl(id: string | number, initial = false): [boolean, (active: boolean) => void] {
  const pathname = usePathname();
  const idStr = String(id);
  const [active, setActiveState,] = useState(initial);

  // Re-read on each route change (back/forward, link nav) so the state is
  // restored when returning to a page that had it active.
  useEffect(() => {
    setActiveState(getList(`a`).includes(idStr));
  }, [pathname, idStr,]);

  function setActive(next: boolean) {
    setActiveState(next);
    toggleInList(`a`, idStr, next);
  }

  return [active, setActive,];
}
